import Grid from "@material-ui/core/Grid";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import Button from "@material-ui/core/Button";
import { instance } from "../../../../Actions/AxiosInstance";
import { DateConversion } from "../../../../Utils/dates";
import { getFormattedDate } from "../../../../Utils";
import addressEmployee from "../../../../Assets/Images/medical.svg";
import { CustomForm } from "../../../../Assets/Js/CustomForm";
import FloatingActionButtons from "../../../../Component/FloatingActionButton/FloatingActionButtons";
import createstore from "../../../../store";
import EmpMedicalIssueForm from "./EmpMedicalIssueForm";
import If from "../../../../Component/Common/If";
import CreateComp from "../create";
import { NoRecordFound } from "./NoRecordFound";

class EmpMedical extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: 3,
      allMedicalsDetails: [],
      successFlag: false,
      hideButton: false,
      dataReceived: false,
      masterprofileid:null,
    };
  }

  componentDidMount() {
    // CustomForm();
  }

  componentWillMount() {
    // this.props.ChangeLanguage("");
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    // let employeeid = SubscriptionInfo.SubscriptionData.employeeid;
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      "",
    );
    let ShortDateFormat = DateFormat.split(" ");
    ShortDateFormat = ShortDateFormat[0];
    let employeeid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;

    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    let hideButton;
    permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        ShortDateFormat,
        colleagueid,
        hideButton,
        masterprofileid
      },
      () => {
        this.GetAllMedicalsDetails();
      },
    );
  }

  SetFlag(value, success, e) {
    const flag = value;
    const successFlag = success;
    this.setState({ flag, MedicalDetails: {}, successFlag }, () => {
      if (flag != 1) this.GetAllMedicalsDetails();
      this.props.UpdateStrength(true);
    });
  }

  GetAllMedicalsDetails() {
    const URL = "employee/getempallmedical";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        if (result.data.result.length == 0) {
          this.setState({ flag: 0, dataReceived: true });
        } else {
          this.setState({
            allMedicalsDetails: result.data.result,
            flag: 3,
            dataReceived: true,
          });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetPerticularMedicalDetails(value, data, e) {
    const MedicalDetails = data;
    const flag = value;
    this.setState({ MedicalDetails, flag });
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  ChangeTab() {
    this.props.ChangeTab(6);
  }

  DeleteEmpMedicalDetails = (item) => {
    const employeeid = this.props.colleagueid || this.state.employeeid;
    const data = {
      employeeid : employeeid,
    }
    const URL = `employee/deleteempmedical/${item.employeemedicalconditionid}`;
    instance
      .delete(URL, this.state.masterprofileid && this.state.masterprofileid == 9 && {data})
      .then((resp) => {
        this.GetAllMedicalsDetails();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  };

  // _onCreate = () => {
  //   // this.SetFlag(2);
  //   this.setState({ flag: 2, hideButton: true })
  // }

  Deleteconfirmation = (item) => {
    this.props.enqueueSnackbar(`Are you sure you want to delete?`, {
      variant: "warning",
      action: [
        <Button
          variant="outlined"
          color="inherit"
          className="margin-right-16"
          size="small"
          onClick={() => this.DeleteEmpMedicalDetails(item)}
        >
          Delete
        </Button>,
        <Button color="inherit" size="small">
          Cancel
        </Button>,
      ],
    });
  };

  render() {
    const { classes } = this.props;
    const { ShortDateFormat, hideButton, dataReceived } = this.state;

    let model;
    const { flag } = this.state;
    if (flag === 0) {
      model = (
        <div>
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {!hideButton ? (
                <CreateComp
                  text="Tell us about your ailments that can help us in emergencies"
                  heading={
                    <FormattedMessage
                      id="LbAnyMedicalHistory"
                      defaultMessage="Any medical history?"
                    />
                  }
                  onCreate={this.SetFlag.bind(this, 1, false)}
                  imageSrc={addressEmployee}
                />
              ) : (
                <NoRecordFound />
              )}
            </Grid>
          </Grid>
        </div>
      );
    }

    if (flag === 1) {
      model = (
        // <div className='emp-from-wrapper imp-dates'>
        <EmpMedicalIssueForm
          SetFlag={this.SetFlag.bind(this)}
          data={this.state.MedicalDetails}
          {...this.props}
        />
        // </div>
      );
    }

    if (flag === 2) {
      model = (
        <div>
          <p className="input-form-label address-label">
            {" "}
            <FormattedMessage
              id="Lbanyotherhealthissueyouhavefaced"
              defaultMessage="Would you like to mention more health issues?"
            />{" "}
          </p>
          <div
            className="form-btn form-control margin-right-20"
            onClick={this.SetFlag.bind(this, 1, false)}
          >
            <FormattedMessage id="Btyes" defaultMessage="Yes" />
          </div>
          <div
            className="form-btn form-control"
            onClick={this.SetFlag.bind(this, 3, false)}
          >
            <FormattedMessage id="Btno" defaultMessage="No" />
          </div>
        </div>
      );
    }
    if (flag === 3) {
      model = (
        <div className="profile-data-view-page">
          {this.state.allMedicalsDetails.length > 0 ? (
            <div>
              {this.state.allMedicalsDetails.map((data) => (
                <div className="width100">
                  <div className="padding-bottom-20 position-rel">
                    <div className="inlineClass t-16">
                      {data.condition}
                      <br />
                      {/* {DateConversion(data.dob, ShortDateFormat)} */}
                      {getFormattedDate(data.conditionstartdate)}
                      {data.conditionenddate ? " to " : ""}
                      {data.conditionenddate
                        ? getFormattedDate(data.conditionenddate)
                        : ""}
                    </div>

                    <If condition={!hideButton}>
                      <div>
                        <svg
                          className={"address-edit cursour-pointer"}
                          onClick={this.GetPerticularMedicalDetails.bind(
                            this,
                            1,
                            data,
                          )}
                          width="24"
                          style={{ marginRight: 40 }}
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                        </svg>
                        <svg
                          className={"address-edit cursour-pointer"}
                          onClick={() => this.Deleteconfirmation(data)}
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z" />
                          <path fill="none" d="M0 0h24v24H0V0z" />
                        </svg>
                      </div>
                    </If>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <NoRecordFound />
          )}
          {!hideButton && (
            <div
              className={
                this.state.hideButton ? "hide-button" : "add-more-button"
              }
              onClick={this.SetFlag.bind(this, 1, false)}
              style={{ bottom: 5 }}
            >
              <Button variant="contained" color="primary" className="no-shadow">
                Add More
              </Button>
            </div>
          )}
        </div>
      );
    }
    return (
      <If condition={dataReceived}>
        <div>{model}</div>
      </If>
    );
  }
}
EmpMedical.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withSnackbar(EmpMedical);
